import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ChatBubbleOutlinedIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M20 2.73169H4C2.9 2.73169 2 3.56584 2 4.58535V21.2683L6 17.561H20C21.1 17.561 22 16.7268 22 15.7073V4.58535C22 3.56584 21.1 2.73169 20 2.73169ZM20 15.7073H6L4 17.561V4.58535H20V15.7073Z"
            fill="#222"
          />
          <path
            d="M8.48141 12.4995H7.13875V13.8476H8.48141V12.4995zM9.82418 6.43299H6.46753V7.78111H9.15285V9.12922H7.13886V11.1514H8.48152V10.4773H9.82418C10.1949 10.4773 10.4955 10.1755 10.4955 9.80328V7.10705C10.4955 6.73483 10.1949 6.43299 9.82418 6.43299zM14.7692 10.5623L12.9762 8.7621 12 9.74222 14.7692 12.5227 18.9231 8.35198 17.9469 7.37186 14.7692 10.5623z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
